














































import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";


import { removeOu } from "../../../utils/cookies";
import ChangePassword from "@/views/ou/user/changePassword.vue";

@Component({
  name: "Navbar",
  components: {
    Breadcrumb,
    Hamburger,
    ChangePassword
  }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    return UserModule.getAvatar;
  }

  get userName() {
    return UserModule.getFullName;
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  async logout() {
    // await UserModule.LogOut()
    await removeOu();
    UserModule.Logout();
    this.$router.push({name:'login'})
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }

    defineImg = require('@/assets/images/default-header.png')

  private async changePassword() {
    (this.$refs.changePasswordForm as any).show = true;
  }
}
